@if(!field.props?.hidden) {
  @if (!showHeaders(field.props)) {
    <ng-template #fieldComponent></ng-template>
  } @else if (!options.formState.disabled) {
    <div class="wrapper-container">
      <div id="{{field.key}}" class="formly-field-wrapper">
        @if(field.props?.label) {
        <label class="field-label">{{field.props?.label || '' | translate}}
          @if(field.props?.required && field.form?.enabled && !options.formState.disabled && !field.props?.disabled) {
          <span class="required">*</span>
          }
        </label>
        }
        @if(field.props?.['helpText'] && !options.formState.disabled && !field.props?.disabled) {
        <i (click)="showHelpText(field.props)" class="help-icon fa-solid fa-circle-question">
        </i>
        }
      </div>
      <div class="field-wrapper">
        <ng-template #fieldComponent></ng-template>
      </div>
      @if(formControl && formControl.errors && !options.formState.disabled && !field.props?.disabled) {
        <div class="validation-errors">
          @for(error of getErrorMessages(); track $index) {
            <div class="validation-error">{{error | translate}}</div>
          }
        </div>
      }
    </div>
  } @else if (isDefined()) {
    @if(!options.formState.isSummary || !field.props?.['hideInSummary']) {
      <div
        [class]="'inline-formly-field-wrapper' + (['PICTURE', 'HTML', 'REPEAT','SIGNATURE', 'DOCUMENTS', 'CLIENT_SELECT'].includes(field.type + '' || '') ? '-display-block' : ''  )">
        <div class="label-icon-container">
          @if(field.props && field.props['icon']) {
            <app-dynamic-icon [name]="field.props['icon']" class="field-icon"></app-dynamic-icon>
          }
          @if(field.props?.label) {
            <span [class]="'inline-field-label' + (['DOCUMENTS'].includes(field.type + '' || '') ? ' hidden' : ''  )">{{ field.props?.label! | translate }}:</span>
          }
        </div>
        <div class="field-wrapper">
          <ng-template #fieldComponent></ng-template>
        </div>
      </div>
    }
  }
}